export default function toggleCheckboxHTML(
  baseHTML: string,
  checkboxId: string,
  checked: boolean,
) {
  const valueToReplace = checked
    ? `id="${checkboxId}" checked="${checked}">`
    : `id="${checkboxId}">`;

  const res = baseHTML
    .replaceAll(new RegExp(' data-opentech-ux-zone-id=".*?"', 'gi'), '')
    .replace(
      new RegExp(`id="${checkboxId}"( checked=".*?")?>`, 'i'),
      valueToReplace,
    );
  return res;
}
